import './hampshirehe2/style';
import FormStructure from './hampshirehe2/form_structure';

export default FormStructure;